import reducer from "./reducers";

export { default as paymentTypeOperations } from "./operations";

export default reducer;
